import Swal from "sweetalert2";
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
              <router-link to="/stock/stockin-list">{{$t('stock_in_list')}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">[{{stockin.Num}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="printClick"><i class="fa fa-print"></i> {{ $t('print') }}</button>
            <template v-if="stockin.Status === 'Draft'">
                <router-link :to="{ name: 'stock_in_update', params: { id: $route.params.id }}" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-pencil"></i> {{$t('edit')}}</router-link>
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onApprove"><i class="fa fa-check"></i> {{ $t('approval') }}</button>
                <button type="button" class="btn btn-outline-danger btn-sm no-bor" @click="confirmDelete"><i class="fa fa-times"></i> {{ $t('delete') }}</button>
            </template>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="table-print">
                                <tbody>
                                    <tr>
                                        <td style="width: 100px;">{{ $t('vendor') }}</td>
                                        <td style="width: 15px;">:</td>
                                        <td>{{stockin.VendorName}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('branch_name') }}</td>
                                        <td style="width: 15px;">:</td>
                                        <td>{{stockin.BranchName}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('receiver') }}</td>
                                        <td>:</td>
                                        <td>{{stockin.EmployeeName}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="table-print" align="right">
                                <tbody>
                                    <tr>
                                        <td>{{ $t('stock_in_no') }}</td>
                                        <td style="width: 15px;">:</td>
                                        <td style="min-width: 150px;">{{stockin.Num}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{$t('date')}}</td>
                                        <td>:</td>
                                        <td>{{$format(stockin.InDateAt, 'DD/MM/YYYY')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('item_code')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th class="text-center" style="width: 120px;">{{$t('qty')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td class="text-center">{{index + 1}}</td>
                                        <td>{{ret.ItemCode}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td>{{ret.Description}}</td>
                                        <td class="text-center">{{ret.QuantityIn}}</td>
                                        <td>{{ret.UomName}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-sm-6">
                            {{$t('note')}}: {{stockin.Description}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import { Stock } from '../../shared/models/model';
export default {
    data(){
        return {
            stockin: {
                Status: 'Draft'
            },
            lines: []
        }
    },
    created(){
        var id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.findById(id);
        }
    },
    methods: {
        findById(id){
            let loading = this.$loading.show();
            Stock.findStockin({ Id: id }).then(res => {
                this.stockin = res.Json.Header;
                this.lines = res.Json.Lines;
                this.title = '['+this.stockin.Num+']';
            }).finally(() => { loading.hide(); });
        },
        onApprove(){
            let loading = this.$loading.show();
            Stock.approveStockin({ Id: this.$route.params.id }).then(() => {
                this.$router.go(-1);
            }).finally(() => { loading.hide(); });
        },
        printClick(){
            let url = '/print/stockin/' + this.$route.params.id;
            window.open(url, '_blank');
        },
        confirmDelete(){
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    this.deleteById();
                }
            });
        },
        deleteById(){
            let id = this.$route.params.id;
            let loading = this.$loading.show();
            this.$api().post('stockin/delete', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    this.$router.go(-1);
                }
            }).finally(function(){ loading.hide(); });
        }
    }
}
</script>
<style scoped>
    .table-print thead tr th,
    .table-print tbody tr td{
        padding: 5px 0;
    }
</style>
